import qs from 'qs'
import { axios } from '@/utils/request'
export const api = {
  XqDcBid: {
    add: '/api/1/demandBid/addBidDcXmXx.json',
    edit: '/api/1/demandBid/editBidDcXmXx.json',
    delete: '/api/1/demandBid/delBidDcXmXx.json',
    get: '/api/1/demandBid/getBidDcXmXxById.json',
    query: '/api/1/demandBid/queryBidDcXmXx.json',
    checkBidDcXmBh: '/api/1/demandBid/checkBidDcXmBh.json',
    updateDcXmBlZt: '/api/1/demandBid/updateDcXmBlZt.json',
  },
  XqDcAnnounce: {
    get: '/api/1/demandAnnounce/getBidAnnounceById.json',
    sendToWeb: '/api/1/demandAnnounce/sendBidAnnounce.json',
    updateBidNode: '/api/1/demandAnnounce/updateBidNode.json',
  },
  XqDcAttend: {
    getList: '/api/1/demandAttend/getDemandAttendGys.json',
    editAttendGys: '/api/1/demandAttend/editDemandAttendGys.json',
    delDcAttend: '/api/1/demandAttend/delDcAttend.json',
    addAttendSupper: '/api/1/demandAttend/addAttendSupper.json',
  },
  XqDcFile: {
    addFileSupplier: '/api/1/demandFile/addFileSupplier.json',
  },

}
//需求调查项目
export const AddBidDcXmXx=(bidDxXmXx)=>axios.post(api.XqDcBid.add,qs.stringify(bidDxXmXx)) //添加项目
export const EditBidDcXmXx = (bidDxXmXx) =>axios.post(api.XqDcBid.edit,qs.stringify(bidDxXmXx))//编辑项目
export const DelBidDcXmXx =(id) =>axios.post(api.XqDcBid.delete,qs.stringify({id}))//删除项目
export const GetBidDcXmXxById =(xmid) =>axios.get(api.XqDcBid.get,{params:{xmid}})//根据xmid获取项目数据
export const QueryBidDcXmXx =(bidDxXmXx) =>axios.get(api.XqDcBid.query,{params:{...bidDxXmXx}})//分页获取项目数据
export const CheckBidDcXmBh =(xmid,xmbh) =>axios.get(api.XqDcBid.checkBidDcXmBh,{params:{xmid,xmbh}})//校验项目编号唯一
export const UpdateDcXmBlZt =(xmid,blzt) =>axios.post(api.XqDcBid.updateDcXmBlZt,qs.stringify({xmid,blzt}))//更新办理状态
//需求调查公告
export const GetBidDcAnnounceById =(xmid,announceId) =>axios.get(api.XqDcAnnounce.get,{params:{xmid,announceId}})//根据xmid,announceId获取公告项目数据
export const SendBidAnnounce =(announceId) =>axios.post(api.XqDcAnnounce.sendToWeb,qs.stringify({announceId}))//根据announceId发送公告到网站
export const UpdateBidNode =(xmid,node) =>axios.post(api.XqDcAnnounce.updateBidNode,qs.stringify({xmid,node}))//根据xmid更新项目节点，用户红点标识
//需求调查报名管理
export const GetBidDcAttendGysList =(xmid) =>axios.get(api.XqDcAttend.getList,{params:{xmid}})//根据xmid获取报名供应商
export const EditDemandAttendGys =(attend) =>axios.post(api.XqDcAttend.editAttendGys,qs.stringify(attend))//根据xmid获取报名供应商
export const DelDcAttend =(id) =>axios.post(api.XqDcAttend.delDcAttend,qs.stringify({id}))//根据id删除报名供应商
export const AddAttendSupper =(attend) =>axios.post(api.XqDcAttend.addAttendSupper,qs.stringify(attend))//添加报名供应商
//需求调查供应商响应文件
export const AddFileSupplier =(zgys) =>axios.post(api.XqDcFile.addFileSupplier,qs.stringify(zgys))//添加响应供应商
